import React from 'react';
import '../assets/styles/components/Pagination.sass';

const Pagination = ({ pages, currentPage, city, handleClick }) => {
  const printPages = new Array(pages).fill(0);

  return (
    <ul className={`Pagination --${city}`}>
      {printPages.map((item, index) => (
        <li>
          <button
            className={currentPage === index+1 && '--active'}
            onClick={() => handleClick(index+1)}
          >
            {index + 1}
          </button>
        </li>
      ))}
    </ul>
  )
};

export default Pagination;
